const CONTACT_DETAILS_STORAGE_KEY = 'clipstone_contact_details';

const DEFAULT_CONTACT_DETAILS = {
  trust: {
    address: 'Mansfield Road, Clipstone, NG21 9AL',
    phone: '01623 627006 / 01623 622098',
    email: 'clipstonewelfarecommunitytrust@yahoo.co.uk',
    emailSubject: 'Contact Request',
    emailBody: 'Hello Clipstone Welfare Community Trust,\n\nI have a question about...',
    hours: [
      { day: 'Monday', hours: '9:00 am - 5:00 pm' },
      { day: 'Tuesday', hours: '9:00 am - 5:00 pm' },
      { day: 'Wednesday', hours: '9:00 am - 5:00 pm' },
      { day: 'Thursday', hours: '9:00 am - 5:00 pm' },
      { day: 'Friday', hours: '9:00 am - 5:00 pm' },
      { day: 'Saturday', hours: '9:00 am - 5:00 pm' },
      { day: 'Sunday', hours: '9:00 am - 5:00 pm' },
    ],
  },
  social: {
    address: 'Mansfield Road, Clipstone, NG21 9AL',
    phone: '01623 622098',
    email: 'clipstonesocialclub@yahoo.com',
    emailSubject: 'Social Club Enquiry',
    emailBody: 'Hello Clipstone Social Club,\n\n',
    hours: [
      { day: 'Monday', hours: '9:00 am - 5:00 pm' },
      { day: 'Tuesday', hours: '9:00 am - 5:00 pm' },
      { day: 'Wednesday', hours: '9:00 am - 5:00 pm' },
      { day: 'Thursday', hours: '9:00 am - 5:00 pm' },
      { day: 'Friday', hours: '9:00 am - 5:00 pm' },
      { day: 'Saturday', hours: '9:00 am - 5:00 pm' },
      { day: 'Sunday', hours: '9:00 am - 5:00 pm' },
    ],
    officeHoursLabel: 'Monday to Sunday',
    officeHours: '9:00 am - 5:00 pm',
  },
};

const cloneValue = (value) => JSON.parse(JSON.stringify(value));

const safeParse = (value) => {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const normalizeHoursList = (hoursList, defaultHours) => {
  if (!Array.isArray(hoursList) || hoursList.length === 0) {
    return cloneValue(defaultHours);
  }
  return hoursList.map((entry) => {
    // If it has legacy closed or old evening hours, migrate to 9:00 am - 5:00 pm
    if (entry.hours === 'Closed' || (entry.hours?.includes('pm') && !entry.hours?.includes('9:00 am'))) {
      return { ...entry, hours: '9:00 am - 5:00 pm' };
    }
    return entry;
  });
};

const mergeContactSection = (defaults, stored) => ({
  ...cloneValue(defaults),
  ...(stored || {}),
  hours: normalizeHoursList(stored?.hours, defaults.hours),
});

const getContactDetails = () => {
  const stored = safeParse(window.localStorage.getItem(CONTACT_DETAILS_STORAGE_KEY));

  if (!stored) {
    return cloneValue(DEFAULT_CONTACT_DETAILS);
  }

  const socialMerged = {
    ...cloneValue(DEFAULT_CONTACT_DETAILS.social),
    ...(stored.social || {}),
    hours: normalizeHoursList(stored?.social?.hours, DEFAULT_CONTACT_DETAILS.social.hours),
    officeHours: (stored?.social?.officeHours === '12:30 pm - 2:30 pm' || !stored?.social?.officeHours)
      ? '9:00 am - 5:00 pm'
      : stored.social.officeHours,
    officeHoursLabel: stored?.social?.officeHoursLabel === 'Monday to Friday'
      ? 'Monday to Sunday'
      : (stored?.social?.officeHoursLabel || 'Monday to Sunday'),
  };

  return {
    trust: mergeContactSection(DEFAULT_CONTACT_DETAILS.trust, stored.trust),
    social: socialMerged,
  };
};

const saveContactDetails = (details) => {
  window.localStorage.setItem(CONTACT_DETAILS_STORAGE_KEY, JSON.stringify(details));
  window.dispatchEvent(new Event('contact-details-updated'));
};

const resetContactDetails = () => {
  window.localStorage.removeItem(CONTACT_DETAILS_STORAGE_KEY);
  window.dispatchEvent(new Event('contact-details-updated'));
};

const buildMailtoHref = (email, subject = '', body = '') => {
  const params = new URLSearchParams();

  if (subject) {
    params.set('subject', subject);
  }

  if (body) {
    params.set('body', body);
  }

  const query = params.toString();
  return `mailto:${email}${query ? `?${query}` : ''}`;
};

const normalizePhoneForTel = (phone) => String(phone || '').replace(/[^\d+]/g, '');

export {
  DEFAULT_CONTACT_DETAILS,
  buildMailtoHref,
  getContactDetails,
  normalizePhoneForTel,
  resetContactDetails,
  saveContactDetails,
};